<!--
|--------------------------------------------------
|      询价管理-零件弹窗
| 
| 
| 
|--------------------------------------------------
-->
<template>
<div>
    <el-table :data="partList" row-key="id" size="mini" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
        <el-table-column type="index" width="50" label="序号"> </el-table-column>
        <el-table-column prop="partCode" header-align="center" align="left" label="零件编号" width="200">
        </el-table-column>
        <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="310">
        </el-table-column>
        <el-table-column prop="cancelFlag" header-align="center" align="center" label="取消标识" width="150">
          <template slot-scope="scope">
                  <span>
                      {{ cancelFlagFormat(scope.row.cancelFlag) }}
                  </span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" header-align="center" align="center" label="单位" width="100">
        </el-table-column>
        <el-table-column prop="oneCarCount" header-align="center" align="center" label="单车用量" width="100">
        </el-table-column>
        <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格" width="150">
        </el-table-column>
        <el-table-column prop="targetInvestment" header-align="center" align="right" label="目标工装费" width="150">
        </el-table-column>
        <el-table-column prop="targetDevelopment" header-align="center" align="right" label="目标开发费" width="150">
        </el-table-column>
        <el-table-column prop="targetTestfee" header-align="center" align="right" label="目标试验费" width="150">
        </el-table-column>
        <el-table-column prop="supplyStatus" header-align="center" align="center" label="供货状态" width="150">
            <template slot-scope="scope">
                <span>
                    {{ supplyStatusFormat(scope.row.supplyStatus) }}
                </span>
            </template>
        </el-table-column>
    </el-table>
    <!-- 分页 -->
    <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination> -->
</div>
</template>

<script>
// require('@/mock/mockRFQ');
import {
    DIALOG_CLOSED_TYPE,
    SUPPLY_STATUS,
    getLabelByValue,
    CANCEL_FLAG
} from "@/utils/const";
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        partList: Array,
        viewFlag: Boolean,
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
        };
    },
    components: {},
    mounted() {

    },
    methods: {
        supplyStatusFormat(value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        cancelFlagFormat(value) {
          if (!value) {
            return "";
          }
          return getLabelByValue(CANCEL_FLAG, value);
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getPartList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getPartList()
        },

        // 查所有供应商表
        getPartList() {
            getRfqPartList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                rfqId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    if (data.body) {
                        this.partList = data.body.records
                        console.log(data.body.total)
                        this.totalPage = data.body.total
                    } else {
                        this.partList = []
                        this.totalPage = 0
                    }
                } else {
                    this.partList = []
                    this.totalPage = 0
                }
            })
        },
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.mt20 {
    margin-top: 20px;
}
</style>
